import { useEffect, useState } from "react";
import { Check, Edit3, ThumbsDown, ThumbsUp } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const ICONS = {
  verify_social: Check,
  override_socials: Edit3,
  accept_application: ThumbsUp,
  reject_application: ThumbsDown,
};
const LABEL = {
  verify_social: "verified a social handle on",
  override_socials: "overrode social handles for",
  accept_application: "accepted",
  reject_application: "rejected",
};
const TONE = {
  verify_social: "text-[#A855F7]",
  override_socials: "text-amber-300",
  accept_application: "text-emerald-300",
  reject_application: "text-rose-300",
};

function timeAgo(iso) {
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export default function AdminActivityFeed() {
  const [items, setItems] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [allItems, setAllItems] = useState([]);

  useEffect(() => {
    api.get("/admin/activity?limit=10").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  const openAll = async () => {
    try {
      const r = await api.get("/admin/activity?limit=50");
      setAllItems(r.data.items || []);
      setShowAll(true);
    } catch {}
  };

  const renderItem = (it) => {
    const Icon = ICONS[it.action] || Check;
    const label = LABEL[it.action] || it.action;
    const tone = TONE[it.action] || "text-zinc-300";
    return (
      <li key={it.id} data-testid={`activity-${it.id}`} className="flex items-start gap-3 py-2.5 text-sm">
        <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${tone}`} />
        <div className="flex-1">
          <p className="text-zinc-300">
            <span className="font-mono text-xs text-zinc-500">{it.actor}</span>{" "}
            <span className={tone}>{label}</span>{" "}
            <span className="font-semibold text-white">{it.target?.label || it.target?.id}</span>
            {it.note && <span className="text-zinc-500"> · {it.note}</span>}
          </p>
        </div>
        <span className="shrink-0 font-mono text-[10px] text-zinc-600" title={it.at}>{timeAgo(it.at)}</span>
      </li>
    );
  };

  return (
    <div className="rounded-2xl border border-zinc-900 bg-zinc-950 p-6" data-testid="admin-activity-feed">
      <div className="flex items-baseline justify-between">
        <h3 className="font-display text-lg font-bold">Recent admin activity</h3>
        <button
          onClick={openAll}
          data-testid="admin-activity-view-all"
          className="text-[10px] font-bold uppercase tracking-wider text-[#A855F7] hover:underline"
        >
          View all →
        </button>
      </div>
      <ul className="mt-4 divide-y divide-zinc-900">
        {items.length === 0 && (
          <li className="py-3 text-sm text-zinc-500">No admin actions yet.</li>
        )}
        {items.map(renderItem)}
      </ul>

      <Dialog open={showAll} onOpenChange={setShowAll}>
        <DialogContent className="max-h-[80vh] overflow-y-auto border-zinc-800 bg-zinc-950 sm:max-w-2xl">
          <DialogHeader>
            <DialogTitle>All admin activity (last 50)</DialogTitle>
          </DialogHeader>
          <ul className="divide-y divide-zinc-900">
            {allItems.map(renderItem)}
            {allItems.length === 0 && (
              <li className="py-3 text-sm text-zinc-500">No activity yet.</li>
            )}
          </ul>
        </DialogContent>
      </Dialog>
    </div>
  );
}
